import React from 'react'

const ForbiddenResourceView: React.FC = () => {
  return	(
    <div className="p-forbidden-resource-view">Forbid</div>
  )
};

export default ForbiddenResourceView;
